import ClassCardsList from './ClassCardsList';
import { ClassCardsListProps, ClassCardsListValueProps } from './types';

export type { ClassCardsListProps, ClassCardsListValueProps };
export default ClassCardsList;
